// Format a YYYY-MM-DD (Monday) date for display per language.
export function formatMondayDate(iso, lang = "en") {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  const locale = lang === "fr" ? "fr-FR" : lang === "ht" ? "fr-HT" : "en-US";
  return d.toLocaleDateString(locale, { weekday: "short", month: "short", day: "numeric" });
}

// Return the index (1-12) of the next upcoming cohort week, or null if all past.
export function nextWeek(assignments, now = new Date()) {
  const future = assignments
    .filter((a) => a.live_date)
    .map((a) => ({ ...a, _t: new Date(a.live_date + "T23:59:00").getTime() }))
    .sort((a, b) => a.week - b.week);
  return future.find((a) => a._t >= now.getTime()) || null;
}

// Days remaining until a live session (positive number). 0 = today, negative = past.
export function daysUntil(iso, now = new Date()) {
  if (!iso) return null;
  const target = new Date(iso + "T23:59:00").getTime();
  return Math.floor((target - now.getTime()) / (1000 * 60 * 60 * 24));
}
